/* This is generated code, don't alter */
var IfcWasteTerminalTypeEnum;
(function (IfcWasteTerminalTypeEnum) {
    IfcWasteTerminalTypeEnum[IfcWasteTerminalTypeEnum["FLOORTRAP"] = 0] = "FLOORTRAP";
    IfcWasteTerminalTypeEnum[IfcWasteTerminalTypeEnum["FLOORWASTE"] = 1] = "FLOORWASTE";
    IfcWasteTerminalTypeEnum[IfcWasteTerminalTypeEnum["GULLYSUMP"] = 2] = "GULLYSUMP";
    IfcWasteTerminalTypeEnum[IfcWasteTerminalTypeEnum["GULLYTRAP"] = 3] = "GULLYTRAP";
    IfcWasteTerminalTypeEnum[IfcWasteTerminalTypeEnum["ROOFDRAIN"] = 4] = "ROOFDRAIN";
    IfcWasteTerminalTypeEnum[IfcWasteTerminalTypeEnum["WASTEDISPOSALUNIT"] = 5] = "WASTEDISPOSALUNIT";
    IfcWasteTerminalTypeEnum[IfcWasteTerminalTypeEnum["WASTETRAP"] = 6] = "WASTETRAP";
    IfcWasteTerminalTypeEnum[IfcWasteTerminalTypeEnum["USERDEFINED"] = 7] = "USERDEFINED";
    IfcWasteTerminalTypeEnum[IfcWasteTerminalTypeEnum["NOTDEFINED"] = 8] = "NOTDEFINED";
})(IfcWasteTerminalTypeEnum || (IfcWasteTerminalTypeEnum = {}));
const IfcWasteTerminalTypeEnumCount = 9;
export { IfcWasteTerminalTypeEnum, IfcWasteTerminalTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcWasteTerminalTypeEnum = new Int32Array([-7, 1, 117]);
let prefixSumAddressIfcWasteTerminalTypeEnum = new Uint32Array([0, 12, 23, 42, 53, 64, 75, 86, 99, 111]);
let slotMapIfcWasteTerminalTypeEnum = new Int32Array([8, 0, 5, 6, 3, 4, 2, 7, 1]);
let encodedDataIfcWasteTerminalTypeEnum = (new TextEncoder()).encode(".NOTDEFINED..FLOORTRAP..WASTEDISPOSALUNIT..WASTETRAP..GULLYTRAP..ROOFDRAIN..GULLYSUMP..USERDEFINED..FLOORWASTE.");
let IfcWasteTerminalTypeEnumSearch = new MinimalPerfectHash(gMapIfcWasteTerminalTypeEnum, prefixSumAddressIfcWasteTerminalTypeEnum, slotMapIfcWasteTerminalTypeEnum, encodedDataIfcWasteTerminalTypeEnum);
export { IfcWasteTerminalTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcWasteTerminalTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcWasteTerminalTypeEnumSearch, input, cursor, endCursor);
}
